export const stateWiseCities = [
	{
		state: 'Alabama',
		abbreviation: 'AL',
		cities: [
			{
				name: 'Tuscaloosa',
				slug: 'Tuscaloosa-AL-self-storage.html',
				yearly_visitors: 432,
			},
			{
				name: 'Auburn',
				slug: 'Auburn-AL-self-storage.html',
				yearly_visitors: 407,
			},
			{
				name: 'Birmingham',
				slug: 'Birmingham-AL-self-storage.html',
				yearly_visitors: 346,
			},
			{
				name: 'Dothan',
				slug: 'Dothan-AL-self-storage.html',
				yearly_visitors: 302,
			},
			{
				name: 'Montgomery',
				slug: 'Montgomery-AL-self-storage.html',
				yearly_visitors: 301,
			},
			{
				name: 'Huntsville',
				slug: 'Huntsville-AL-self-storage.html',
				yearly_visitors: 283,
			},
			{
				name: 'Phenix City',
				slug: 'Phenix-City-AL-self-storage.html',
				yearly_visitors: 179,
			},
			{
				name: 'Cullman',
				slug: 'Cullman-AL-self-storage.html',
				yearly_visitors: 169,
			},
			{
				name: 'Florence',
				slug: 'Florence-AL-self-storage.html',
				yearly_visitors: 157,
			},
			{
				name: 'Mobile',
				slug: 'Mobile-AL-self-storage.html',
				yearly_visitors: 129,
			},
		],
	},
	{
		state: 'Alaska',
		abbreviation: 'AK',
		cities: [
			{
				name: 'Anchorage',
				slug: 'Anchorage-AK-self-storage.html',
				yearly_visitors: 525,
			},
			{
				name: 'Fairbanks',
				slug: 'Fairbanks-AK-self-storage.html',
				yearly_visitors: 147,
			},
			{
				name: 'Wasilla',
				slug: 'Wasilla-AK-self-storage.html',
				yearly_visitors: 51,
			},
			{
				name: 'Juneau',
				slug: 'Juneau-AK-self-storage.html',
				yearly_visitors: 30,
			},
			{
				name: 'Soldotna',
				slug: 'Soldotna-AK-self-storage.html',
				yearly_visitors: 24,
			},
			{
				name: 'Kenai',
				slug: 'Kenai-AK-self-storage.html',
				yearly_visitors: 20,
			},
			{
				name: 'Eagle River',
				slug: 'Eagle-River-AK-self-storage.html',
				yearly_visitors: 17,
			},
			{
				name: 'Palmer',
				slug: 'Palmer-AK-self-storage.html',
				yearly_visitors: 13,
			},
			{
				name: 'Ketchikan',
				slug: 'Ketchikan-AK-self-storage.html',
				yearly_visitors: 7,
			},
			{
				name: 'Willow',
				slug: 'Willow-AK-self-storage.html',
				yearly_visitors: 7,
			},
		],
	},
	{
		state: 'Arizona',
		abbreviation: 'AZ',
		cities: [
			{
				name: 'Phoenix',
				slug: 'Phoenix-AZ-self-storage.html',
				yearly_visitors: 3386,
			},
			{
				name: 'Tucson',
				slug: 'Tucson-AZ-self-storage.html',
				yearly_visitors: 1266,
			},
			{
				name: 'Mesa',
				slug: 'Mesa-AZ-self-storage.html',
				yearly_visitors: 876,
			},
			{
				name: 'Yuma',
				slug: 'Yuma-AZ-self-storage.html',
				yearly_visitors: 560,
			},
			{
				name: 'Tempe',
				slug: 'Tempe-AZ-self-storage.html',
				yearly_visitors: 559,
			},
			{
				name: 'Glendale',
				slug: 'Glendale-AZ-self-storage.html',
				yearly_visitors: 536,
			},
			{
				name: 'Chandler',
				slug: 'Chandler-AZ-self-storage.html',
				yearly_visitors: 429,
			},
			{
				name: 'Scottsdale',
				slug: 'Scottsdale-AZ-self-storage.html',
				yearly_visitors: 419,
			},
			{
				name: 'Gilbert',
				slug: 'Gilbert-AZ-self-storage.html',
				yearly_visitors: 298,
			},
			{
				name: 'Kingman',
				slug: 'Kingman-AZ-self-storage.html',
				yearly_visitors: 274,
			},
		],
	},
	{
		state: 'Arkansas',
		abbreviation: 'AR',
		cities: [
			{
				name: 'Fayetteville',
				slug: 'Fayetteville-AR-self-storage.html',
				yearly_visitors: 764,
			},
			{
				name: 'Little Rock',
				slug: 'Little-Rock-AR-self-storage.html',
				yearly_visitors: 403,
			},
			{
				name: 'Jonesboro',
				slug: 'Jonesboro-AR-self-storage.html',
				yearly_visitors: 292,
			},
			{
				name: 'Fort Smith',
				slug: 'Fort-Smith-AR-self-storage.html',
				yearly_visitors: 277,
			},
			{
				name: 'Conway',
				slug: 'Conway-AR-self-storage.html',
				yearly_visitors: 183,
			},
			{
				name: 'Russellville',
				slug: 'Russellville-AR-self-storage.html',
				yearly_visitors: 169,
			},
			{
				name: 'Springdale',
				slug: 'Springdale-AR-self-storage.html',
				yearly_visitors: 149,
			},
			{
				name: 'Rogers',
				slug: 'Rogers-AR-self-storage.html',
				yearly_visitors: 143,
			},
			{
				name: 'Hot Springs',
				slug: 'Hot-Springs-AR-self-storage.html',
				yearly_visitors: 133,
			},
			{
				name: 'Bentonville',
				slug: 'Bentonville-AR-self-storage.html',
				yearly_visitors: 126,
			},
		],
	},
	{
		state: 'California',
		abbreviation: 'CA',
		cities: [
			{
				name: 'Los Angeles',
				slug: 'Los-Angeles-CA-self-storage.html',
				yearly_visitors: 7785,
			},
			{
				name: 'San Diego',
				slug: 'San-Diego-CA-self-storage.html',
				yearly_visitors: 4235,
			},
			{
				name: 'San Francisco',
				slug: 'San-Francisco-CA-self-storage.html',
				yearly_visitors: 2470,
			},
			{
				name: 'San Jose',
				slug: 'San-Jose-CA-self-storage.html',
				yearly_visitors: 1903,
			},
			{
				name: 'Sacramento',
				slug: 'Sacramento-CA-self-storage.html',
				yearly_visitors: 1823,
			},
			{
				name: 'Fresno',
				slug: 'Fresno-CA-self-storage.html',
				yearly_visitors: 1228,
			},
			{
				name: 'Long Beach',
				slug: 'Long-Beach-CA-self-storage.html',
				yearly_visitors: 1132,
			},
			{
				name: 'Anaheim',
				slug: 'Anaheim-CA-self-storage.html',
				yearly_visitors: 1028,
			},
			{
				name: 'Chula Vista',
				slug: 'Chula-Vista-CA-self-storage.html',
				yearly_visitors: 1021,
			},
			{
				name: 'Oakland',
				slug: 'Oakland-CA-self-storage.html',
				yearly_visitors: 1013,
			},
		],
	},
	{
		state: 'Colorado',
		abbreviation: 'CO',
		cities: [
			{
				name: 'Denver',
				slug: 'Denver-CO-self-storage.html',
				yearly_visitors: 2722,
			},
			{
				name: 'Aurora',
				slug: 'Aurora-CO-self-storage.html',
				yearly_visitors: 1796,
			},
			{
				name: 'Colorado Springs',
				slug: 'Colorado-Springs-CO-self-storage.html',
				yearly_visitors: 1514,
			},
			{
				name: 'Fort Collins',
				slug: 'Fort-Collins-CO-self-storage.html',
				yearly_visitors: 1301,
			},
			{
				name: 'Lakewood',
				slug: 'Lakewood-CO-self-storage.html',
				yearly_visitors: 1214,
			},
			{
				name: 'Grand Junction',
				slug: 'Grand-Junction-CO-self-storage.html',
				yearly_visitors: 836,
			},
			{
				name: 'Boulder',
				slug: 'Boulder-CO-self-storage.html',
				yearly_visitors: 791,
			},
			{
				name: 'Greeley',
				slug: 'Greeley-CO-self-storage.html',
				yearly_visitors: 551,
			},
			{
				name: 'Longmont',
				slug: 'Longmont-CO-self-storage.html',
				yearly_visitors: 405,
			},
			{
				name: 'Loveland',
				slug: 'Loveland-CO-self-storage.html',
				yearly_visitors: 395,
			},
		],
	},
	{
		state: 'Connecticut',
		abbreviation: 'CT',
		cities: [
			{
				name: 'New Haven',
				slug: 'New-Haven-CT-self-storage.html',
				yearly_visitors: 483,
			},
			{
				name: 'Stamford',
				slug: 'Stamford-CT-self-storage.html',
				yearly_visitors: 417,
			},
			{
				name: 'Hartford',
				slug: 'Hartford-CT-self-storage.html',
				yearly_visitors: 314,
			},
			{
				name: 'Bridgeport',
				slug: 'Bridgeport-CT-self-storage.html',
				yearly_visitors: 271,
			},
			{
				name: 'Waterbury',
				slug: 'Waterbury-CT-self-storage.html',
				yearly_visitors: 230,
			},
			{
				name: 'New Britain',
				slug: 'New-Britain-CT-self-storage.html',
				yearly_visitors: 199,
			},
			{
				name: 'Norwalk',
				slug: 'Norwalk-CT-self-storage.html',
				yearly_visitors: 180,
			},
			{
				name: 'Danbury',
				slug: 'Danbury-CT-self-storage.html',
				yearly_visitors: 152,
			},
			{
				name: 'Storrs',
				slug: 'Storrs-CT-self-storage.html',
				yearly_visitors: 144,
			},
			{
				name: 'Greenwich',
				slug: 'Greenwich-CT-self-storage.html',
				yearly_visitors: 124,
			},
		],
	},
	{
		state: 'Delaware',
		abbreviation: 'DE',
		cities: [
			{
				name: 'Dover',
				slug: 'Dover-DE-self-storage.html',
				yearly_visitors: 285,
			},
			{
				name: 'Wilmington',
				slug: 'Wilmington-DE-self-storage.html',
				yearly_visitors: 137,
			},
			{
				name: 'Middletown',
				slug: 'Middletown-DE-self-storage.html',
				yearly_visitors: 103,
			},
			{
				name: 'Newark',
				slug: 'Newark-DE-self-storage.html',
				yearly_visitors: 100,
			},
			{
				name: 'Lewes',
				slug: 'Lewes-DE-self-storage.html',
				yearly_visitors: 84,
			},
			{
				name: 'New Castle',
				slug: 'New-Castle-DE-self-storage.html',
				yearly_visitors: 52,
			},
			{
				name: 'Rehoboth Beach',
				slug: 'Rehoboth-Beach-DE-self-storage.html',
				yearly_visitors: 51,
			},
			{
				name: 'Milford',
				slug: 'Milford-DE-self-storage.html',
				yearly_visitors: 50,
			},
			{
				name: 'Millsboro',
				slug: 'Millsboro-DE-self-storage.html',
				yearly_visitors: 46,
			},
			{
				name: 'Seaford',
				slug: 'Seaford-DE-self-storage.html',
				yearly_visitors: 39,
			},
		],
	},
	{
		state: 'Florida',
		abbreviation: 'FL',
		cities: [
			{
				name: 'Miami',
				slug: 'Miami-FL-self-storage.html',
				yearly_visitors: 3387,
			},
			{
				name: 'Tampa',
				slug: 'Tampa-FL-self-storage.html',
				yearly_visitors: 2277,
			},
			{
				name: 'Tallahassee',
				slug: 'Tallahassee-FL-self-storage.html',
				yearly_visitors: 2252,
			},
			{
				name: 'Orlando',
				slug: 'Orlando-FL-self-storage.html',
				yearly_visitors: 2110,
			},
			{
				name: 'Jacksonville',
				slug: 'Jacksonville-FL-self-storage.html',
				yearly_visitors: 1547,
			},
			{
				name: 'Hollywood',
				slug: 'Hollywood-FL-self-storage.html',
				yearly_visitors: 1369,
			},
			{
				name: 'St Petersburg',
				slug: 'St-Petersburg-FL-self-storage.html',
				yearly_visitors: 1125,
			},
			{
				name: 'Fort Lauderdale',
				slug: 'Fort-Lauderdale-FL-self-storage.html',
				yearly_visitors: 1081,
			},
			{
				name: 'Gainesville',
				slug: 'Gainesville-FL-self-storage.html',
				yearly_visitors: 994,
			},
			{
				name: 'Bradenton',
				slug: 'Bradenton-FL-self-storage.html',
				yearly_visitors: 779,
			},
		],
	},
	{
		state: 'Georgia',
		abbreviation: 'GA',
		cities: [
			{
				name: 'Atlanta',
				slug: 'Atlanta-GA-self-storage.html',
				yearly_visitors: 2491,
			},
			{
				name: 'Savannah',
				slug: 'Savannah-GA-self-storage.html',
				yearly_visitors: 1004,
			},
			{
				name: 'Marietta',
				slug: 'Marietta-GA-self-storage.html',
				yearly_visitors: 442,
			},
			{
				name: 'Athens',
				slug: 'Athens-GA-self-storage.html',
				yearly_visitors: 360,
			},
			{
				name: 'Augusta',
				slug: 'Augusta-GA-self-storage.html',
				yearly_visitors: 334,
			},
			{
				name: 'Columbus',
				slug: 'Columbus-GA-self-storage.html',
				yearly_visitors: 297,
			},
			{
				name: 'Alpharetta',
				slug: 'Alpharetta-GA-self-storage.html',
				yearly_visitors: 296,
			},
			{
				name: 'Lawrenceville',
				slug: 'Lawrenceville-GA-self-storage.html',
				yearly_visitors: 264,
			},
			{
				name: 'Statesboro',
				slug: 'Statesboro-GA-self-storage.html',
				yearly_visitors: 255,
			},
			{
				name: 'Brunswick',
				slug: 'Brunswick-GA-self-storage.html',
				yearly_visitors: 227,
			},
		],
	},
	{
		state: 'Hawaii',
		abbreviation: 'HI',
		cities: [
			{
				name: 'Honolulu',
				slug: 'Honolulu-HI-self-storage.html',
				yearly_visitors: 435,
			},
			{
				name: 'Hilo',
				slug: 'Hilo-HI-self-storage.html',
				yearly_visitors: 90,
			},
			{
				name: 'Kahului',
				slug: 'Kahului-HI-self-storage.html',
				yearly_visitors: 45,
			},
			{
				name: 'Ewa Beach',
				slug: 'Ewa-Beach-HI-self-storage.html',
				yearly_visitors: 41,
			},
			{
				name: 'Kapolei',
				slug: 'Kapolei-HI-self-storage.html',
				yearly_visitors: 36,
			},
			{
				name: 'Pearl City',
				slug: 'Pearl-City-HI-self-storage.html',
				yearly_visitors: 34,
			},
			{
				name: 'Waipahu',
				slug: 'Waipahu-HI-self-storage.html',
				yearly_visitors: 27,
			},
			{
				name: 'Kaneohe',
				slug: 'Kaneohe-HI-self-storage.html',
				yearly_visitors: 25,
			},
			{
				name: 'Lihue',
				slug: 'Lihue-HI-self-storage.html',
				yearly_visitors: 25,
			},
			{
				name: 'Wailuku',
				slug: 'Wailuku-HI-self-storage.html',
				yearly_visitors: 23,
			},
		],
	},
	{
		state: 'Idaho',
		abbreviation: 'ID',
		cities: [
			{
				name: 'Boise',
				slug: 'Boise-ID-self-storage.html',
				yearly_visitors: 860,
			},
			{
				name: 'Idaho Falls',
				slug: 'Idaho-Falls-ID-self-storage.html',
				yearly_visitors: 383,
			},
			{
				name: 'Rexburg',
				slug: 'Rexburg-ID-self-storage.html',
				yearly_visitors: 355,
			},
			{
				name: 'Coeur dAlene',
				slug: 'Coeur-dAlene-ID-self-storage.html',
				yearly_visitors: 279,
			},
			{
				name: 'Twin Falls',
				slug: 'Twin-Falls-ID-self-storage.html',
				yearly_visitors: 246,
			},
			{
				name: 'Nampa',
				slug: 'Nampa-ID-self-storage.html',
				yearly_visitors: 238,
			},
			{
				name: 'Meridian',
				slug: 'Meridian-ID-self-storage.html',
				yearly_visitors: 223,
			},
			{
				name: 'Caldwell',
				slug: 'Caldwell-ID-self-storage.html',
				yearly_visitors: 197,
			},
			{
				name: 'Post Falls',
				slug: 'Post-Falls-ID-self-storage.html',
				yearly_visitors: 111,
			},
			{
				name: 'Pocatello',
				slug: 'Pocatello-ID-self-storage.html',
				yearly_visitors: 108,
			},
		],
	},
	{
		state: 'Illinois',
		abbreviation: 'IL',
		cities: [
			{
				name: 'Chicago',
				slug: 'Chicago-IL-self-storage.html',
				yearly_visitors: 3078,
			},
			{
				name: 'Springfield',
				slug: 'Springfield-IL-self-storage.html',
				yearly_visitors: 1124,
			},
			{
				name: 'Champaign',
				slug: 'Champaign-IL-self-storage.html',
				yearly_visitors: 553,
			},
			{
				name: 'Rockford',
				slug: 'Rockford-IL-self-storage.html',
				yearly_visitors: 301,
			},
			{
				name: 'Naperville',
				slug: 'Naperville-IL-self-storage.html',
				yearly_visitors: 234,
			},
			{
				name: 'Carbondale',
				slug: 'Carbondale-IL-self-storage.html',
				yearly_visitors: 198,
			},
			{
				name: 'Bloomington',
				slug: 'Bloomington-IL-self-storage.html',
				yearly_visitors: 191,
			},
			{
				name: 'DeKalb',
				slug: 'DeKalb-IL-self-storage.html',
				yearly_visitors: 178,
			},
			{
				name: 'Peoria',
				slug: 'Peoria-IL-self-storage.html',
				yearly_visitors: 174,
			},
			{
				name: 'Schaumburg',
				slug: 'Schaumburg-IL-self-storage.html',
				yearly_visitors: 156,
			},
		],
	},
	{
		state: 'Indiana',
		abbreviation: 'IN',
		cities: [
			{
				name: 'Indianapolis',
				slug: 'Indianapolis-IN-self-storage.html',
				yearly_visitors: 993,
			},
			{
				name: 'Fort Wayne',
				slug: 'Fort-Wayne-IN-self-storage.html',
				yearly_visitors: 401,
			},
			{
				name: 'Evansville',
				slug: 'Evansville-IN-self-storage.html',
				yearly_visitors: 379,
			},
			{
				name: 'Bloomington',
				slug: 'Bloomington-IN-self-storage.html',
				yearly_visitors: 376,
			},
			{
				name: 'West Lafayette',
				slug: 'West-Lafayette-IN-self-storage.html',
				yearly_visitors: 310,
			},
			{
				name: 'Lafayette',
				slug: 'Lafayette-IN-self-storage.html',
				yearly_visitors: 279,
			},
			{
				name: 'Terre Haute',
				slug: 'Terre-Haute-IN-self-storage.html',
				yearly_visitors: 233,
			},
			{
				name: 'South Bend',
				slug: 'South-Bend-IN-self-storage.html',
				yearly_visitors: 206,
			},
			{
				name: 'Portage',
				slug: 'Portage-IN-self-storage.html',
				yearly_visitors: 191,
			},
			{
				name: 'Elkhart',
				slug: 'Elkhart-IN-self-storage.html',
				yearly_visitors: 188,
			},
		],
	},
	{
		state: 'Iowa',
		abbreviation: 'IA',
		cities: [
			{
				name: 'Des Moines',
				slug: 'Des-Moines-IA-self-storage.html',
				yearly_visitors: 342,
			},
			{
				name: 'Davenport',
				slug: 'Davenport-IA-self-storage.html',
				yearly_visitors: 282,
			},
			{
				name: 'Iowa City',
				slug: 'Iowa-City-IA-self-storage.html',
				yearly_visitors: 255,
			},
			{
				name: 'Cedar Rapids',
				slug: 'Cedar-Rapids-IA-self-storage.html',
				yearly_visitors: 245,
			},
			{
				name: 'Waterloo',
				slug: 'Waterloo-IA-self-storage.html',
				yearly_visitors: 216,
			},
			{
				name: 'Ames',
				slug: 'Ames-IA-self-storage.html',
				yearly_visitors: 162,
			},
			{
				name: 'Dubuque',
				slug: 'Dubuque-IA-self-storage.html',
				yearly_visitors: 159,
			},
			{
				name: 'Council Bluffs',
				slug: 'Council-Bluffs-IA-self-storage.html',
				yearly_visitors: 136,
			},
			{
				name: 'Coralville',
				slug: 'Coralville-IA-self-storage.html',
				yearly_visitors: 101,
			},
			{
				name: 'Sioux City',
				slug: 'Sioux-City-IA-self-storage.html',
				yearly_visitors: 94,
			},
		],
	},

	{
		state: 'Kansas',
		abbreviation: 'KS',
		cities: [
			{
				name: 'Wichita',
				slug: 'Wichita-KS-self-storage.html',
				yearly_visitors: 728,
			},
			{
				name: 'Manhattan',
				slug: 'Manhattan-KS-self-storage.html',
				yearly_visitors: 475,
			},
			{
				name: 'Topeka',
				slug: 'Topeka-KS-self-storage.html',
				yearly_visitors: 425,
			},
			{
				name: 'Junction City',
				slug: 'Junction-City-KS-self-storage.html',
				yearly_visitors: 278,
			},
			{
				name: 'Lawrence',
				slug: 'Lawrence-KS-self-storage.html',
				yearly_visitors: 238,
			},
			{
				name: 'Kansas City',
				slug: 'Kansas-City-KS-self-storage.html',
				yearly_visitors: 171,
			},
			{
				name: 'Olathe',
				slug: 'Olathe-KS-self-storage.html',
				yearly_visitors: 162,
			},
			{
				name: 'Overland Park',
				slug: 'Overland-Park-KS-self-storage.html',
				yearly_visitors: 129,
			},
			{
				name: 'Atchison',
				slug: 'Atchison-KS-self-storage.html',
				yearly_visitors: 128,
			},
			{
				name: 'Salina',
				slug: 'Salina-KS-self-storage.html',
				yearly_visitors: 121,
			},
		],
	},

	{
		state: 'Kentucky',
		abbreviation: 'KY',
		cities: [
			{
				name: 'Lexington',
				slug: 'Lexington-KY-self-storage.html',
				yearly_visitors: 792,
			},
			{
				name: 'Louisville',
				slug: 'Louisville-KY-self-storage.html',
				yearly_visitors: 711,
			},
			{
				name: 'Bowling Green',
				slug: 'Bowling-Green-KY-self-storage.html',
				yearly_visitors: 369,
			},
			{
				name: 'Radcliff',
				slug: 'Radcliff-KY-self-storage.html',
				yearly_visitors: 168,
			},
			{
				name: 'Paducah',
				slug: 'Paducah-KY-self-storage.html',
				yearly_visitors: 163,
			},
			{
				name: 'Richmond',
				slug: 'Richmond-KY-self-storage.html',
				yearly_visitors: 156,
			},
			{
				name: 'Owensboro',
				slug: 'Owensboro-KY-self-storage.html',
				yearly_visitors: 138,
			},
			{
				name: 'Somerset',
				slug: 'Somerset-KY-self-storage.html',
				yearly_visitors: 136,
			},
			{
				name: 'Florence',
				slug: 'Florence-KY-self-storage.html',
				yearly_visitors: 123,
			},
			{
				name: 'Hopkinsville',
				slug: 'Hopkinsville-KY-self-storage.html',
				yearly_visitors: 120,
			},
		],
	},

	{
		state: 'Louisiana',
		abbreviation: 'LA',
		cities: [
			{
				name: 'New Orleans',
				slug: 'New-Orleans-LA-self-storage.html',
				yearly_visitors: 610,
			},
			{
				name: 'Baton Rouge',
				slug: 'Baton-Rouge-LA-self-storage.html',
				yearly_visitors: 580,
			},
			{
				name: 'Lafayette',
				slug: 'Lafayette-LA-self-storage.html',
				yearly_visitors: 295,
			},
			{
				name: 'Shreveport',
				slug: 'Shreveport-LA-self-storage.html',
				yearly_visitors: 275,
			},
			{
				name: 'Monroe',
				slug: 'Monroe-LA-self-storage.html',
				yearly_visitors: 190,
			},
			{
				name: 'Lake Charles',
				slug: 'Lake-Charles-LA-self-storage.html',
				yearly_visitors: 155,
			},
			{
				name: 'Metairie',
				slug: 'Metairie-LA-self-storage.html',
				yearly_visitors: 138,
			},
			{
				name: 'Slidell',
				slug: 'Slidell-LA-self-storage.html',
				yearly_visitors: 135,
			},
			{
				name: 'Ruston',
				slug: 'Ruston-LA-self-storage.html',
				yearly_visitors: 110,
			},
			{
				name: 'Alexandria',
				slug: 'Alexandria-LA-self-storage.html',
				yearly_visitors: 97,
			},
		],
	},

	{
		state: 'Maine',
		abbreviation: 'ME',
		cities: [
			{
				name: 'Portland',
				slug: 'Portland-ME-self-storage.html',
				yearly_visitors: 306,
			},
			{
				name: 'Bangor',
				slug: 'Bangor-ME-self-storage.html',
				yearly_visitors: 195,
			},
			{
				name: 'Lewiston',
				slug: 'Lewiston-ME-self-storage.html',
				yearly_visitors: 73,
			},
			{
				name: 'Yarmouth',
				slug: 'Yarmouth-ME-self-storage.html',
				yearly_visitors: 51,
			},
			{
				name: 'South Portland',
				slug: 'South-Portland-ME-self-storage.html',
				yearly_visitors: 50,
			},
			{
				name: 'Auburn',
				slug: 'Auburn-ME-self-storage.html',
				yearly_visitors: 47,
			},
			{
				name: 'Old Orchard Beach',
				slug: 'Old-Orchard-Beach-ME-self-storage.html',
				yearly_visitors: 45,
			},
			{
				name: 'Orono',
				slug: 'Orono-ME-self-storage.html',
				yearly_visitors: 44,
			},
			{
				name: 'Brunswick',
				slug: 'Brunswick-ME-self-storage.html',
				yearly_visitors: 43,
			},
			{
				name: 'Scarborough',
				slug: 'Scarborough-ME-self-storage.html',
				yearly_visitors: 41,
			},
		],
	},

	{
		state: 'Maryland',
		abbreviation: 'MD',
		cities: [
			{
				name: 'Baltimore',
				slug: 'Baltimore-MD-self-storage.html',
				yearly_visitors: 1194,
			},
			{
				name: 'Rockville',
				slug: 'Rockville-MD-self-storage.html',
				yearly_visitors: 432,
			},
			{
				name: 'Hagerstown',
				slug: 'Hagerstown-MD-self-storage.html',
				yearly_visitors: 398,
			},
			{
				name: 'Silver Spring',
				slug: 'Silver-Spring-MD-self-storage.html',
				yearly_visitors: 343,
			},
			{
				name: 'Frederick',
				slug: 'Frederick-MD-self-storage.html',
				yearly_visitors: 340,
			},
			{
				name: 'Westminster',
				slug: 'Westminster-MD-self-storage.html',
				yearly_visitors: 325,
			},
			{
				name: 'Bethesda',
				slug: 'Bethesda-MD-self-storage.html',
				yearly_visitors: 271,
			},
			{
				name: 'Gaithersburg',
				slug: 'Gaithersburg-MD-self-storage.html',
				yearly_visitors: 244,
			},
			{
				name: 'Germantown',
				slug: 'Germantown-MD-self-storage.html',
				yearly_visitors: 197,
			},
			{
				name: 'Bowie',
				slug: 'Bowie-MD-self-storage.html',
				yearly_visitors: 195,
			},
		],
	},
	{
		state: 'Massachusetts',
		abbreviation: 'MA',
		cities: [
			{
				name: 'Boston',
				slug: 'Boston-MA-self-storage.html',
				yearly_visitors: 1663,
			},
			{
				name: 'Springfield',
				slug: 'Springfield-MA-self-storage.html',
				yearly_visitors: 434,
			},
			{
				name: 'Cambridge',
				slug: 'Cambridge-MA-self-storage.html',
				yearly_visitors: 384,
			},
			{
				name: 'Worcester',
				slug: 'Worcester-MA-self-storage.html',
				yearly_visitors: 342,
			},
			{
				name: 'Amherst',
				slug: 'Amherst-MA-self-storage.html',
				yearly_visitors: 334,
			},
			{
				name: 'Brighton',
				slug: 'Brighton-MA-self-storage.html',
				yearly_visitors: 312,
			},
			{
				name: 'Hyannis',
				slug: 'Hyannis-MA-self-storage.html',
				yearly_visitors: 238,
			},
			{
				name: 'Quincy',
				slug: 'Quincy-MA-self-storage.html',
				yearly_visitors: 190,
			},
			{
				name: 'Revere',
				slug: 'Revere-MA-self-storage.html',
				yearly_visitors: 189,
			},
			{
				name: 'Waltham',
				slug: 'Waltham-MA-self-storage.html',
				yearly_visitors: 177,
			},
		],
	},
	{
		state: 'Michigan',
		abbreviation: 'MI',
		cities: [
			{
				name: 'Detroit',
				slug: 'Detroit-MI-self-storage.html',
				yearly_visitors: 756,
			},
			{
				name: 'Grand Rapids',
				slug: 'Grand-Rapids-MI-self-storage.html',
				yearly_visitors: 476,
			},
			{
				name: 'Kalamazoo',
				slug: 'Kalamazoo-MI-self-storage.html',
				yearly_visitors: 377,
			},
			{
				name: 'Muskegon',
				slug: 'Muskegon-MI-self-storage.html',
				yearly_visitors: 308,
			},
			{
				name: 'Mount Pleasant',
				slug: 'Mount-Pleasant-MI-self-storage.html',
				yearly_visitors: 300,
			},
			{
				name: 'Ann Arbor',
				slug: 'Ann-Arbor-MI-self-storage.html',
				yearly_visitors: 248,
			},
			{
				name: 'Lansing',
				slug: 'Lansing-MI-self-storage.html',
				yearly_visitors: 244,
			},
			{
				name: 'Flint',
				slug: 'Flint-MI-self-storage.html',
				yearly_visitors: 228,
			},
			{
				name: 'Holland',
				slug: 'Holland-MI-self-storage.html',
				yearly_visitors: 198,
			},
			{
				name: 'Pontiac',
				slug: 'Pontiac-MI-self-storage.html',
				yearly_visitors: 197,
			},
		],
	},
	{
		state: 'Minnesota',
		abbreviation: 'MN',
		cities: [
			{
				name: 'Minneapolis',
				slug: 'Minneapolis-MN-self-storage.html',
				yearly_visitors: 1058,
			},
			{
				name: 'Duluth',
				slug: 'Duluth-MN-self-storage.html',
				yearly_visitors: 555,
			},
			{
				name: 'St Paul',
				slug: 'St-Paul-MN-self-storage.html',
				yearly_visitors: 441,
			},
			{
				name: 'Mankato',
				slug: 'Mankato-MN-self-storage.html',
				yearly_visitors: 227,
			},
			{
				name: 'Rochester',
				slug: 'Rochester-MN-self-storage.html',
				yearly_visitors: 175,
			},
			{
				name: 'Moorhead',
				slug: 'Moorhead-MN-self-storage.html',
				yearly_visitors: 173,
			},
			{
				name: 'St Cloud',
				slug: 'St-Cloud-MN-self-storage.html',
				yearly_visitors: 172,
			},
			{
				name: 'Burnsville',
				slug: 'Burnsville-MN-self-storage.html',
				yearly_visitors: 132,
			},
			{
				name: 'Richfield',
				slug: 'Richfield-MN-self-storage.html',
				yearly_visitors: 102,
			},
			{
				name: 'Shakopee',
				slug: 'Shakopee-MN-self-storage.html',
				yearly_visitors: 102,
			},
		],
	},
	{
		state: 'Mississippi',
		abbreviation: 'MS',
		cities: [
			{
				name: 'Oxford',
				slug: 'Oxford-MS-self-storage.html',
				yearly_visitors: 309,
			},
			{
				name: 'Starkville',
				slug: 'Starkville-MS-self-storage.html',
				yearly_visitors: 202,
			},
			{
				name: 'Jackson',
				slug: 'Jackson-MS-self-storage.html',
				yearly_visitors: 187,
			},
			{
				name: 'Gulfport',
				slug: 'Gulfport-MS-self-storage.html',
				yearly_visitors: 165,
			},
			{
				name: 'Hattiesburg',
				slug: 'Hattiesburg-MS-self-storage.html',
				yearly_visitors: 155,
			},
			{
				name: 'Tupelo',
				slug: 'Tupelo-MS-self-storage.html',
				yearly_visitors: 115,
			},
			{
				name: 'Biloxi',
				slug: 'Biloxi-MS-self-storage.html',
				yearly_visitors: 99,
			},
			{
				name: 'Southaven',
				slug: 'Southaven-MS-self-storage.html',
				yearly_visitors: 98,
			},
			{
				name: 'Columbus',
				slug: 'Columbus-MS-self-storage.html',
				yearly_visitors: 92,
			},
			{
				name: 'Batesville',
				slug: 'Batesville-MS-self-storage.html',
				yearly_visitors: 79,
			},
		],
	},
	{
		state: 'Missouri',
		abbreviation: 'MO',
		cities: [
			{
				name: 'Kansas City',
				slug: 'Kansas-City-MO-self-storage.html',
				yearly_visitors: 1065,
			},
			{
				name: 'St Louis',
				slug: 'St-Louis-MO-self-storage.html',
				yearly_visitors: 863,
			},
			{
				name: 'Springfield',
				slug: 'Springfield-MO-self-storage.html',
				yearly_visitors: 814,
			},
			{
				name: 'Columbia',
				slug: 'Columbia-MO-self-storage.html',
				yearly_visitors: 687,
			},
			{
				name: 'Joplin',
				slug: 'Joplin-MO-self-storage.html',
				yearly_visitors: 296,
			},
			{
				name: 'Jefferson City',
				slug: 'Jefferson-City-MO-self-storage.html',
				yearly_visitors: 291,
			},
			{
				name: 'Independence',
				slug: 'Independence-MO-self-storage.html',
				yearly_visitors: 179,
			},
			{
				name: 'Lees Summit',
				slug: 'Lees-Summit-MO-self-storage.html',
				yearly_visitors: 157,
			},
			{
				name: 'Rolla',
				slug: 'Rolla-MO-self-storage.html',
				yearly_visitors: 124,
			},
			{
				name: 'Branson',
				slug: 'Branson-MO-self-storage.html',
				yearly_visitors: 117,
			},
		],
	},
	{
		state: 'Montana',
		abbreviation: 'MT',
		cities: [
			{
				name: 'Missoula',
				slug: 'Missoula-MT-self-storage.html',
				yearly_visitors: 535,
			},
			{
				name: 'Billings',
				slug: 'Billings-MT-self-storage.html',
				yearly_visitors: 345,
			},
			{
				name: 'Bozeman',
				slug: 'Bozeman-MT-self-storage.html',
				yearly_visitors: 327,
			},
			{
				name: 'Great Falls',
				slug: 'Great-Falls-MT-self-storage.html',
				yearly_visitors: 230,
			},
			{
				name: 'Kalispell',
				slug: 'Kalispell-MT-self-storage.html',
				yearly_visitors: 189,
			},
			{
				name: 'Helena',
				slug: 'Helena-MT-self-storage.html',
				yearly_visitors: 134,
			},
			{
				name: 'Butte',
				slug: 'Butte-MT-self-storage.html',
				yearly_visitors: 69,
			},
			{
				name: 'Whitefish',
				slug: 'Whitefish-MT-self-storage.html',
				yearly_visitors: 60,
			},
			{
				name: 'Belgrade',
				slug: 'Belgrade-MT-self-storage.html',
				yearly_visitors: 58,
			},
			{
				name: 'Hamilton',
				slug: 'Hamilton-MT-self-storage.html',
				yearly_visitors: 39,
			},
		],
	},
	{
		state: 'Nebraska',
		abbreviation: 'NE',
		cities: [
			{
				name: 'Omaha',
				slug: 'Omaha-NE-self-storage.html',
				yearly_visitors: 836,
			},
			{
				name: 'Lincoln',
				slug: 'Lincoln-NE-self-storage.html',
				yearly_visitors: 409,
			},
			{
				name: 'Bellevue',
				slug: 'Bellevue-NE-self-storage.html',
				yearly_visitors: 163,
			},
			{
				name: 'Grand Island',
				slug: 'Grand-Island-NE-self-storage.html',
				yearly_visitors: 84,
			},
			{
				name: 'Norfolk',
				slug: 'Norfolk-NE-self-storage.html',
				yearly_visitors: 78,
			},
			{
				name: 'Hastings',
				slug: 'Hastings-NE-self-storage.html',
				yearly_visitors: 51,
			},
			{
				name: 'Newton',
				slug: 'Newton-NE-self-storage.html',
				yearly_visitors: 41,
			},
			{
				name: 'Columbus',
				slug: 'Columbus-NE-self-storage.html',
				yearly_visitors: 37,
			},
			{
				name: 'Fremont',
				slug: 'Fremont-NE-self-storage.html',
				yearly_visitors: 37,
			},
			{
				name: 'Scottsbluff',
				slug: 'Scottsbluff-NE-self-storage.html',
				yearly_visitors: 36,
			},
		],
	},
	{
		state: 'Nevada',
		abbreviation: 'NV',
		cities: [
			{
				name: 'Las Vegas',
				slug: 'Las-Vegas-NV-self-storage.html',
				yearly_visitors: 3546,
			},
			{
				name: 'Henderson',
				slug: 'Henderson-NV-self-storage.html',
				yearly_visitors: 324,
			},
			{
				name: 'North Las Vegas',
				slug: 'North-Las-Vegas-NV-self-storage.html',
				yearly_visitors: 280,
			},
			{
				name: 'Sparks',
				slug: 'Sparks-NV-self-storage.html',
				yearly_visitors: 240,
			},
			{
				name: 'Fallon',
				slug: 'Fallon-NV-self-storage.html',
				yearly_visitors: 219,
			},
			{
				name: 'Carson City',
				slug: 'Carson-City-NV-self-storage.html',
				yearly_visitors: 148,
			},
			{
				name: 'Pahrump',
				slug: 'Pahrump-NV-self-storage.html',
				yearly_visitors: 122,
			},
			{
				name: 'Fernley',
				slug: 'Fernley-NV-self-storage.html',
				yearly_visitors: 77,
			},
			{
				name: 'Elko',
				slug: 'Elko-NV-self-storage.html',
				yearly_visitors: 63,
			},
			{
				name: 'Laughlin',
				slug: 'Laughlin-NV-self-storage.html',
				yearly_visitors: 42,
			},
		],
	},
	{
		state: 'New Hampshire',
		abbreviation: 'NH',
		cities: [
			{
				name: 'Manchester',
				slug: 'Manchester-NH-self-storage.html',
				yearly_visitors: 155,
			},
			{
				name: 'Salem',
				slug: 'Salem-NH-self-storage.html',
				yearly_visitors: 102,
			},
			{
				name: 'Durham',
				slug: 'Durham-NH-self-storage.html',
				yearly_visitors: 85,
			},
			{
				name: 'Laconia',
				slug: 'Laconia-NH-self-storage.html',
				yearly_visitors: 83,
			},
			{
				name: 'Nashua',
				slug: 'Nashua-NH-self-storage.html',
				yearly_visitors: 71,
			},
			{
				name: 'Hanover',
				slug: 'Hanover-NH-self-storage.html',
				yearly_visitors: 69,
			},
			{
				name: 'Rochester',
				slug: 'Rochester-NH-self-storage.html',
				yearly_visitors: 59,
			},
			{
				name: 'Concord',
				slug: 'Concord-NH-self-storage.html',
				yearly_visitors: 58,
			},
			{
				name: 'Hampton',
				slug: 'Hampton-NH-self-storage.html',
				yearly_visitors: 55,
			},
			{
				name: 'Dover',
				slug: 'Dover-NH-self-storage.html',
				yearly_visitors: 53,
			},
		],
	},
	{
		state: 'New Jersey',
		abbreviation: 'NJ',
		cities: [
			{
				name: 'Jersey City',
				slug: 'Jersey-City-NJ-self-storage.html',
				yearly_visitors: 1568,
			},
			{
				name: 'Newark',
				slug: 'Newark-NJ-self-storage.html',
				yearly_visitors: 593,
			},
			{
				name: 'Paterson',
				slug: 'Paterson-NJ-self-storage.html',
				yearly_visitors: 465,
			},
			{
				name: 'Edison',
				slug: 'Edison-NJ-self-storage.html',
				yearly_visitors: 361,
			},
			{
				name: 'East Orange',
				slug: 'East-Orange-NJ-self-storage.html',
				yearly_visitors: 323,
			},
			{
				name: 'Princeton',
				slug: 'Princeton-NJ-self-storage.html',
				yearly_visitors: 304,
			},
			{
				name: 'Atlantic City',
				slug: 'Atlantic-City-NJ-self-storage.html',
				yearly_visitors: 284,
			},
			{
				name: 'Elizabeth',
				slug: 'Elizabeth-NJ-self-storage.html',
				yearly_visitors: 283,
			},
			{
				name: 'Hackensack',
				slug: 'Hackensack-NJ-self-storage.html',
				yearly_visitors: 256,
			},
			{
				name: 'Camden',
				slug: 'Camden-NJ-self-storage.html',
				yearly_visitors: 206,
			},
		],
	},
	{
		state: 'New Mexico',
		abbreviation: 'NM',
		cities: [
			{
				name: 'Albuquerque',
				slug: 'Albuquerque-NM-self-storage.html',
				yearly_visitors: 1128,
			},
			{
				name: 'Las Cruces',
				slug: 'Las-Cruces-NM-self-storage.html',
				yearly_visitors: 421,
			},
			{
				name: 'Lovington',
				slug: 'Lovington-NM-self-storage.html',
				yearly_visitors: 307,
			},
			{
				name: 'Santa Fe',
				slug: 'Santa-Fe-NM-self-storage.html',
				yearly_visitors: 165,
			},
			{
				name: 'Carlsbad',
				slug: 'Carlsbad-NM-self-storage.html',
				yearly_visitors: 149,
			},
			{
				name: 'Clovis',
				slug: 'Clovis-NM-self-storage.html',
				yearly_visitors: 112,
			},
			{
				name: 'Rio Rancho',
				slug: 'Rio-Rancho-NM-self-storage.html',
				yearly_visitors: 85,
			},
			{
				name: 'Alamogordo',
				slug: 'Alamogordo-NM-self-storage.html',
				yearly_visitors: 79,
			},
			{
				name: 'Las Vegas',
				slug: 'Las-Vegas-NM-self-storage.html',
				yearly_visitors: 54,
			},
		],
	},
	{
		state: 'New York',
		abbreviation: 'NY',
		cities: [
			{
				name: 'New York',
				slug: 'New-York-NY-self-storage.html',
				yearly_visitors: 5445,
			},
			{
				name: 'Brooklyn',
				slug: 'Brooklyn-NY-self-storage.html',
				yearly_visitors: 3391,
			},
			{
				name: 'Queens',
				slug: 'Queens-NY-self-storage.html',
				yearly_visitors: 2687,
			},
			{
				name: 'Bronx',
				slug: 'Bronx-NY-self-storage.html',
				yearly_visitors: 1096,
			},
			{
				name: 'Rochester',
				slug: 'Rochester-NY-self-storage.html',
				yearly_visitors: 1057,
			},
			{
				name: 'Troy',
				slug: 'Troy-NY-self-storage.html',
				yearly_visitors: 970,
			},
			{
				name: 'Buffalo',
				slug: 'Buffalo-NY-self-storage.html',
				yearly_visitors: 879,
			},
			{
				name: 'Staten Island',
				slug: 'Staten-Island-NY-self-storage.html',
				yearly_visitors: 769,
			},
			{
				name: 'Manhattan',
				slug: 'Manhattan-NY-self-storage.html',
				yearly_visitors: 642,
			},
			{
				name: 'Syracuse',
				slug: 'Syracuse-NY-self-storage.html',
				yearly_visitors: 628,
			},
		],
	},
	{
		state: 'North Carolina',
		abbreviation: 'NC',
		cities: [
			{
				name: 'Charlotte',
				slug: 'Charlotte-NC-self-storage.html',
				yearly_visitors: 1791,
			},
			{
				name: 'Raleigh',
				slug: 'Raleigh-NC-self-storage.html',
				yearly_visitors: 1479,
			},
			{
				name: 'Greensboro',
				slug: 'Greensboro-NC-self-storage.html',
				yearly_visitors: 883,
			},
			{
				name: 'Wilmington',
				slug: 'Wilmington-NC-self-storage.html',
				yearly_visitors: 677,
			},
			{
				name: 'Durham',
				slug: 'Durham-NC-self-storage.html',
				yearly_visitors: 651,
			},
			{
				name: 'Fayetteville',
				slug: 'Fayetteville-NC-self-storage.html',
				yearly_visitors: 582,
			},
			{
				name: 'Jacksonville',
				slug: 'Jacksonville-NC-self-storage.html',
				yearly_visitors: 498,
			},
			{
				name: 'Greenville',
				slug: 'Greenville-NC-self-storage.html',
				yearly_visitors: 472,
			},
			{
				name: 'Winston-Salem',
				slug: 'Winston-Salem-NC-self-storage.html',
				yearly_visitors: 447,
			},
			{
				name: 'Asheville',
				slug: 'Asheville-NC-self-storage.html',
				yearly_visitors: 421,
			},
		],
	},
	{
		state: 'North Dakota',
		abbreviation: 'ND',
		cities: [
			{
				name: 'Fargo',
				slug: 'Fargo-ND-self-storage.html',
				yearly_visitors: 609,
			},
			{
				name: 'West Fargo',
				slug: 'West-Fargo-ND-self-storage.html',
				yearly_visitors: 218,
			},
			{
				name: 'Grand Forks',
				slug: 'Grand-Forks-ND-self-storage.html',
				yearly_visitors: 206,
			},
			{
				name: 'Minot',
				slug: 'Minot-ND-self-storage.html',
				yearly_visitors: 125,
			},
			{
				name: 'Williston',
				slug: 'Williston-ND-self-storage.html',
				yearly_visitors: 72,
			},
			{
				name: 'Dickinson',
				slug: 'Dickinson-ND-self-storage.html',
				yearly_visitors: 63,
			},
			{
				name: 'Wahpeton',
				slug: 'Wahpeton-ND-self-storage.html',
				yearly_visitors: 38,
			},
			{
				name: 'Belfield',
				slug: 'Belfield-ND-self-storage.html',
				yearly_visitors: 17,
			},
			{
				name: 'Watford City',
				slug: 'Watford-City-ND-self-storage.html',
				yearly_visitors: 15,
			},
			{
				name: 'Devils Lake',
				slug: 'Devils-Lake-ND-self-storage.html',
				yearly_visitors: 13,
			},
		],
	},
	{
		state: 'Ohio',
		abbreviation: 'OH',
		cities: [
			{
				name: 'Columbus',
				slug: 'Columbus-OH-self-storage.html',
				yearly_visitors: 1532,
			},
			{
				name: 'Cleveland',
				slug: 'Cleveland-OH-self-storage.html',
				yearly_visitors: 1211,
			},
			{
				name: 'Cincinnati',
				slug: 'Cincinnati-OH-self-storage.html',
				yearly_visitors: 788,
			},
			{
				name: 'Toledo',
				slug: 'Toledo-OH-self-storage.html',
				yearly_visitors: 646,
			},
			{
				name: 'Dayton',
				slug: 'Dayton-OH-self-storage.html',
				yearly_visitors: 441,
			},
			{
				name: 'Akron',
				slug: 'Akron-OH-self-storage.html',
				yearly_visitors: 423,
			},
			{
				name: 'Athens',
				slug: 'Athens-OH-self-storage.html',
				yearly_visitors: 419,
			},
			{
				name: 'Canton',
				slug: 'Canton-OH-self-storage.html',
				yearly_visitors: 277,
			},
			{
				name: 'Bowling Green',
				slug: 'Bowling-Green-OH-self-storage.html',
				yearly_visitors: 230,
			},
			{
				name: 'Westerville',
				slug: 'Westerville-OH-self-storage.html',
				yearly_visitors: 207,
			},
		],
	},
	{
		state: 'Oklahoma',
		abbreviation: 'OK',
		cities: [
			{
				name: 'Oklahoma City',
				slug: 'Oklahoma-City-OK-self-storage.html',
				yearly_visitors: 1162,
			},
			{
				name: 'Tulsa',
				slug: 'Tulsa-OK-self-storage.html',
				yearly_visitors: 735,
			},
			{
				name: 'Moore',
				slug: 'Moore-OK-self-storage.html',
				yearly_visitors: 216,
			},
			{
				name: 'Edmond',
				slug: 'Edmond-OK-self-storage.html',
				yearly_visitors: 159,
			},
			{
				name: 'Broken Arrow',
				slug: 'Broken-Arrow-OK-self-storage.html',
				yearly_visitors: 158,
			},
			{
				name: 'Norman',
				slug: 'Norman-OK-self-storage.html',
				yearly_visitors: 156,
			},
			{
				name: 'Lawton',
				slug: 'Lawton-OK-self-storage.html',
				yearly_visitors: 146,
			},
			{
				name: 'Newcastle',
				slug: 'Newcastle-OK-self-storage.html',
				yearly_visitors: 130,
			},
			{
				name: 'Enid',
				slug: 'Enid-OK-self-storage.html',
				yearly_visitors: 125,
			},
			{
				name: 'Stillwater',
				slug: 'Stillwater-OK-self-storage.html',
				yearly_visitors: 92,
			},
		],
	},
	{
		state: 'Oregon',
		abbreviation: 'OR',
		cities: [
			{
				name: 'Portland',
				slug: 'Portland-OR-self-storage.html',
				yearly_visitors: 1740,
			},
			{
				name: 'Eugene',
				slug: 'Eugene-OR-self-storage.html',
				yearly_visitors: 626,
			},
			{
				name: 'Medford',
				slug: 'Medford-OR-self-storage.html',
				yearly_visitors: 448,
			},
			{
				name: 'Salem',
				slug: 'Salem-OR-self-storage.html',
				yearly_visitors: 446,
			},
			{
				name: 'Beaverton',
				slug: 'Beaverton-OR-self-storage.html',
				yearly_visitors: 344,
			},
			{
				name: 'Gresham',
				slug: 'Gresham-OR-self-storage.html',
				yearly_visitors: 267,
			},
			{
				name: 'Corvallis',
				slug: 'Corvallis-OR-self-storage.html',
				yearly_visitors: 243,
			},
			{
				name: 'Klamath Falls',
				slug: 'Klamath-Falls-OR-self-storage.html',
				yearly_visitors: 237,
			},
			{
				name: 'Grants Pass',
				slug: 'Grants-Pass-OR-self-storage.html',
				yearly_visitors: 229,
			},
			{
				name: 'Bend',
				slug: 'Bend-OR-self-storage.html',
				yearly_visitors: 190,
			},
		],
	},
	{
		state: 'Pennsylvania',
		abbreviation: 'PA',
		cities: [
			{
				name: 'Philadelphia',
				slug: 'Philadelphia-PA-self-storage.html',
				yearly_visitors: 2271,
			},
			{
				name: 'Pittsburgh',
				slug: 'Pittsburgh-PA-self-storage.html',
				yearly_visitors: 1251,
			},
			{
				name: 'State College',
				slug: 'State-College-PA-self-storage.html',
				yearly_visitors: 669,
			},
			{
				name: 'Lancaster',
				slug: 'Lancaster-PA-self-storage.html',
				yearly_visitors: 641,
			},
			{
				name: 'Harrisburg',
				slug: 'Harrisburg-PA-self-storage.html',
				yearly_visitors: 501,
			},
			{
				name: 'Allentown',
				slug: 'Allentown-PA-self-storage.html',
				yearly_visitors: 452,
			},
			{
				name: 'Erie',
				slug: 'Erie-PA-self-storage.html',
				yearly_visitors: 417,
			},
			{
				name: 'Glenside',
				slug: 'Glenside-PA-self-storage.html',
				yearly_visitors: 351,
			},
			{
				name: 'Reading',
				slug: 'Reading-PA-self-storage.html',
				yearly_visitors: 351,
			},
			{
				name: 'Easton',
				slug: 'Easton-PA-self-storage.html',
				yearly_visitors: 296,
			},
		],
	},
	{
		state: 'Rhode Island',
		abbreviation: 'RI',
		cities: [
			{
				name: 'Providence',
				slug: 'Providence-RI-self-storage.html',
				yearly_visitors: 640,
			},
			{
				name: 'Pawtucket',
				slug: 'Pawtucket-RI-self-storage.html',
				yearly_visitors: 125,
			},
			{
				name: 'Woonsocket',
				slug: 'Woonsocket-RI-self-storage.html',
				yearly_visitors: 79,
			},
			{
				name: 'East Providence',
				slug: 'East-Providence-RI-self-storage.html',
				yearly_visitors: 73,
			},
			{
				name: 'Middletown',
				slug: 'Middletown-RI-self-storage.html',
				yearly_visitors: 69,
			},
			{
				name: 'Westerly',
				slug: 'Westerly-RI-self-storage.html',
				yearly_visitors: 61,
			},
			{
				name: 'Warwick',
				slug: 'Warwick-RI-self-storage.html',
				yearly_visitors: 58,
			},
			{
				name: 'Newport',
				slug: 'Newport-RI-self-storage.html',
				yearly_visitors: 56,
			},
			{
				name: 'Cranston',
				slug: 'Cranston-RI-self-storage.html',
				yearly_visitors: 54,
			},
			{
				name: 'West Warwick',
				slug: 'West-Warwick-RI-self-storage.html',
				yearly_visitors: 54,
			},
		],
	},
	{
		state: 'South Carolina',
		abbreviation: 'SC',
		cities: [
			{
				name: 'Columbia',
				slug: 'Columbia-SC-self-storage.html',
				yearly_visitors: 593,
			},
			{
				name: 'Charleston',
				slug: 'Charleston-SC-self-storage.html',
				yearly_visitors: 582,
			},
			{
				name: 'Greenville',
				slug: 'Greenville-SC-self-storage.html',
				yearly_visitors: 569,
			},
			{
				name: 'Myrtle Beach',
				slug: 'Myrtle-Beach-SC-self-storage.html',
				yearly_visitors: 347,
			},
			{
				name: 'Anderson',
				slug: 'Anderson-SC-self-storage.html',
				yearly_visitors: 259,
			},
			{
				name: 'Rock Hill',
				slug: 'Rock-Hill-SC-self-storage.html',
				yearly_visitors: 241,
			},
			{
				name: 'Spartanburg',
				slug: 'Spartanburg-SC-self-storage.html',
				yearly_visitors: 216,
			},
			{
				name: 'North Charleston',
				slug: 'North-Charleston-SC-self-storage.html',
				yearly_visitors: 199,
			},
			{
				name: 'Conway',
				slug: 'Conway-SC-self-storage.html',
				yearly_visitors: 186,
			},
			{
				name: 'Summerville',
				slug: 'Summerville-SC-self-storage.html',
				yearly_visitors: 184,
			},
		],
	},

	{
		state: 'South Dakota',
		abbreviation: 'SD',
		cities: [
			{
				name: 'Sioux Falls',
				slug: 'Sioux-Falls-SD-self-storage.html',
				yearly_visitors: 533,
			},
			{
				name: 'Rapid City',
				slug: 'Rapid-City-SD-self-storage.html',
				yearly_visitors: 304,
			},
			{
				name: 'Watertown',
				slug: 'Watertown-SD-self-storage.html',
				yearly_visitors: 80,
			},
			{
				name: 'Brookings',
				slug: 'Brookings-SD-self-storage.html',
				yearly_visitors: 36,
			},
			{
				name: 'Spearfish',
				slug: 'Spearfish-SD-self-storage.html',
				yearly_visitors: 25,
			},
			{
				name: 'Mitchell',
				slug: 'Mitchell-SD-self-storage.html',
				yearly_visitors: 16,
			},
			{
				name: 'Huron',
				slug: 'Huron-SD-self-storage.html',
				yearly_visitors: 11,
			},
			{
				name: 'Box Elder',
				slug: 'Box-Elder-SD-self-storage.html',
				yearly_visitors: 9,
			},
			{
				name: 'Hill City',
				slug: 'Hill-City-SD-self-storage.html',
				yearly_visitors: 3,
			},
			{
				name: 'Blackhawk',
				slug: 'Blackhawk-SD-self-storage.html',
				yearly_visitors: 1,
			},
		],
	},
	{
		state: 'Tennessee',
		abbreviation: 'TN',
		cities: [
			{
				name: 'Nashville',
				slug: 'Nashville-TN-self-storage.html',
				yearly_visitors: 1075,
			},
			{
				name: 'Knoxville',
				slug: 'Knoxville-TN-self-storage.html',
				yearly_visitors: 650,
			},
			{
				name: 'Memphis',
				slug: 'Memphis-TN-self-storage.html',
				yearly_visitors: 500,
			},
			{
				name: 'Clarksville',
				slug: 'Clarksville-TN-self-storage.html',
				yearly_visitors: 456,
			},
			{
				name: 'Johnson City',
				slug: 'Johnson-City-TN-self-storage.html',
				yearly_visitors: 427,
			},
			{
				name: 'Murfreesboro',
				slug: 'Murfreesboro-TN-self-storage.html',
				yearly_visitors: 348,
			},
			{
				name: 'Chattanooga',
				slug: 'Chattanooga-TN-self-storage.html',
				yearly_visitors: 310,
			},
			{
				name: 'Franklin',
				slug: 'Franklin-TN-self-storage.html',
				yearly_visitors: 308,
			},
			{
				name: 'Cleveland',
				slug: 'Cleveland-TN-self-storage.html',
				yearly_visitors: 238,
			},
			{
				name: 'Cookeville',
				slug: 'Cookeville-TN-self-storage.html',
				yearly_visitors: 230,
			},
		],
	},
	{
		state: 'Texas',
		abbreviation: 'TX',
		cities: [
			{
				name: 'Austin',
				slug: 'Austin-TX-self-storage.html',
				yearly_visitors: 5411,
			},
			{
				name: 'Houston',
				slug: 'Houston-TX-self-storage.html',
				yearly_visitors: 3626,
			},
			{
				name: 'Dallas',
				slug: 'Dallas-TX-self-storage.html',
				yearly_visitors: 3041,
			},
			{
				name: 'San Antonio',
				slug: 'San-Antonio-TX-self-storage.html',
				yearly_visitors: 2609,
			},
			{
				name: 'El Paso',
				slug: 'El-Paso-TX-self-storage.html',
				yearly_visitors: 1486,
			},
			{
				name: 'Fort Worth',
				slug: 'Fort-Worth-TX-self-storage.html',
				yearly_visitors: 1324,
			},
			{
				name: 'College Station',
				slug: 'College-Station-TX-self-storage.html',
				yearly_visitors: 1116,
			},
			{
				name: 'Abilene',
				slug: 'Abilene-TX-self-storage.html',
				yearly_visitors: 858,
			},
			{
				name: 'Lubbock',
				slug: 'Lubbock-TX-self-storage.html',
				yearly_visitors: 835,
			},
			{
				name: 'Arlington',
				slug: 'Arlington-TX-self-storage.html',
				yearly_visitors: 797,
			},
		],
	},
	{
		state: 'Utah',
		abbreviation: 'UT',
		cities: [
			{
				name: 'Salt Lake City',
				slug: 'Salt-Lake-City-UT-self-storage.html',
				yearly_visitors: 1438,
			},
			{
				name: 'Provo',
				slug: 'Provo-UT-self-storage.html',
				yearly_visitors: 534,
			},
			{
				name: 'Ogden',
				slug: 'Ogden-UT-self-storage.html',
				yearly_visitors: 386,
			},
			{
				name: 'St George',
				slug: 'St-George-UT-self-storage.html',
				yearly_visitors: 357,
			},
			{
				name: 'Murray',
				slug: 'Murray-UT-self-storage.html',
				yearly_visitors: 330,
			},
			{
				name: 'Layton',
				slug: 'Layton-UT-self-storage.html',
				yearly_visitors: 318,
			},
			{
				name: 'Orem',
				slug: 'Orem-UT-self-storage.html',
				yearly_visitors: 281,
			},
			{
				name: 'West Valley City',
				slug: 'West-Valley-City-UT-self-storage.html',
				yearly_visitors: 244,
			},
			{
				name: 'Cedar City',
				slug: 'Cedar-City-UT-self-storage.html',
				yearly_visitors: 191,
			},
			{
				name: 'West Jordan',
				slug: 'West-Jordan-UT-self-storage.html',
				yearly_visitors: 191,
			},
		],
	},
	{
		state: 'Vermont',
		abbreviation: 'VT',
		cities: [
			{
				name: 'Brattleboro',
				slug: 'Brattleboro-VT-self-storage.html',
				yearly_visitors: 79,
			},
			{
				name: 'Rutland',
				slug: 'Rutland-VT-self-storage.html',
				yearly_visitors: 65,
			},
			{
				name: 'Burlington',
				slug: 'Burlington-VT-self-storage.html',
				yearly_visitors: 58,
			},
			{
				name: 'South Burlington',
				slug: 'South-Burlington-VT-self-storage.html',
				yearly_visitors: 36,
			},
			{
				name: 'Bennington',
				slug: 'Bennington-VT-self-storage.html',
				yearly_visitors: 26,
			},
			{
				name: 'Lyndonville',
				slug: 'Lyndonville-VT-self-storage.html',
				yearly_visitors: 11,
			},
			{
				name: 'Williston',
				slug: 'Williston-VT-self-storage.html',
				yearly_visitors: 11,
			},
		],
	},
	{
		state: 'Virginia',
		abbreviation: 'VA',
		cities: [
			{
				name: 'Richmond',
				slug: 'Richmond-VA-self-storage.html',
				yearly_visitors: 1325,
			},
			{
				name: 'Alexandria',
				slug: 'Alexandria-VA-self-storage.html',
				yearly_visitors: 1138,
			},
			{
				name: 'Arlington',
				slug: 'Arlington-VA-self-storage.html',
				yearly_visitors: 794,
			},
			{
				name: 'Virginia Beach',
				slug: 'Virginia-Beach-VA-self-storage.html',
				yearly_visitors: 670,
			},
			{
				name: 'Norfolk',
				slug: 'Norfolk-VA-self-storage.html',
				yearly_visitors: 555,
			},
			{
				name: 'Lynchburg',
				slug: 'Lynchburg-VA-self-storage.html',
				yearly_visitors: 517,
			},
			{
				name: 'Fairfax',
				slug: 'Fairfax-VA-self-storage.html',
				yearly_visitors: 474,
			},
			{
				name: 'Roanoke',
				slug: 'Roanoke-VA-self-storage.html',
				yearly_visitors: 452,
			},
			{
				name: 'Charlottesville',
				slug: 'Charlottesville-VA-self-storage.html',
				yearly_visitors: 439,
			},
			{
				name: 'Blacksburg',
				slug: 'Blacksburg-VA-self-storage.html',
				yearly_visitors: 383,
			},
		],
	},
	{
		state: 'Washington',
		abbreviation: 'WA',
		cities: [
			{
				name: 'Seattle',
				slug: 'Seattle-WA-self-storage.html',
				yearly_visitors: 1709,
			},
			{
				name: 'Spokane',
				slug: 'Spokane-WA-self-storage.html',
				yearly_visitors: 972,
			},
			{
				name: 'Tacoma',
				slug: 'Tacoma-WA-self-storage.html',
				yearly_visitors: 793,
			},
			{
				name: 'Vancouver',
				slug: 'Vancouver-WA-self-storage.html',
				yearly_visitors: 779,
			},
			{
				name: 'Bellingham',
				slug: 'Bellingham-WA-self-storage.html',
				yearly_visitors: 632,
			},
			{
				name: 'Everett',
				slug: 'Everett-WA-self-storage.html',
				yearly_visitors: 508,
			},
			{
				name: 'Kennewick',
				slug: 'Kennewick-WA-self-storage.html',
				yearly_visitors: 382,
			},
			{
				name: 'Yakima',
				slug: 'Yakima-WA-self-storage.html',
				yearly_visitors: 368,
			},
			{
				name: 'Bellevue',
				slug: 'Bellevue-WA-self-storage.html',
				yearly_visitors: 337,
			},
			{
				name: 'Renton',
				slug: 'Renton-WA-self-storage.html',
				yearly_visitors: 314,
			},
		],
	},
	{
		state: 'West Virginia',
		abbreviation: 'WV',
		cities: [
			{
				name: 'Huntington',
				slug: 'Huntington-WV-self-storage.html',
				yearly_visitors: 510,
			},
			{
				name: 'Morgantown',
				slug: 'Morgantown-WV-self-storage.html',
				yearly_visitors: 340,
			},
			{
				name: 'Martinsburg',
				slug: 'Martinsburg-WV-self-storage.html',
				yearly_visitors: 226,
			},
			{
				name: 'Charleston',
				slug: 'Charleston-WV-self-storage.html',
				yearly_visitors: 191,
			},
			{
				name: 'Parkersburg',
				slug: 'Parkersburg-WV-self-storage.html',
				yearly_visitors: 151,
			},
			{
				name: 'Fairmont',
				slug: 'Fairmont-WV-self-storage.html',
				yearly_visitors: 117,
			},
			{
				name: 'Wheeling',
				slug: 'Wheeling-WV-self-storage.html',
				yearly_visitors: 98,
			},
			{
				name: 'Princeton',
				slug: 'Princeton-WV-self-storage.html',
				yearly_visitors: 95,
			},
			{
				name: 'Beckley',
				slug: 'Beckley-WV-self-storage.html',
				yearly_visitors: 80,
			},
			{
				name: 'Charles-Town',
				slug: 'Charles-Town-WV-self-storage.html',
				yearly_visitors: 66,
			},
		],
	},
	{
		state: 'Wisconsin',
		abbreviation: 'WI',
		cities: [
			{
				name: 'Milwaukee',
				slug: 'Milwaukee-WI-self-storage.html',
				yearly_visitors: 798,
			},
			{
				name: 'Madison',
				slug: 'Madison-WI-self-storage.html',
				yearly_visitors: 565,
			},
			{
				name: 'Green Bay',
				slug: 'Green-Bay-WI-self-storage.html',
				yearly_visitors: 422,
			},
			{
				name: 'Eau Claire',
				slug: 'Eau-Claire-WI-self-storage.html',
				yearly_visitors: 303,
			},
			{
				name: 'La Crosse',
				slug: 'La-Crosse-WI-self-storage.html',
				yearly_visitors: 214,
			},
			{
				name: 'Janesville',
				slug: 'Janesville-WI-self-storage.html',
				yearly_visitors: 202,
			},
			{
				name: 'Appleton',
				slug: 'Appleton-WI-self-storage.html',
				yearly_visitors: 196,
			},
			{
				name: 'Wausau',
				slug: 'Wausau-WI-self-storage.html',
				yearly_visitors: 173,
			},
			{
				name: 'Oshkosh',
				slug: 'Oshkosh-WI-self-storage.html',
				yearly_visitors: 160,
			},
			{
				name: 'Stevens Point',
				slug: 'Stevens-Point-WI-self-storage.html',
				yearly_visitors: 158,
			},
		],
	},
	{
		state: 'Wyoming',
		abbreviation: 'WY',
		cities: [
			{
				name: 'Casper',
				slug: 'Casper-WY-self-storage.html',
				yearly_visitors: 309,
			},
			{
				name: 'Cheyenne',
				slug: 'Cheyenne-WY-self-storage.html',
				yearly_visitors: 236,
			},
			{
				name: 'Laramie',
				slug: 'Laramie-WY-self-storage.html',
				yearly_visitors: 79,
			},
			{
				name: 'Sheridan',
				slug: 'Sheridan-WY-self-storage.html',
				yearly_visitors: 42,
			},
			{
				name: 'Jackson',
				slug: 'Jackson-WY-self-storage.html',
				yearly_visitors: 28,
			},
			{
				name: 'Cody',
				slug: 'Cody-WY-self-storage.html',
				yearly_visitors: 22,
			},
			{
				name: 'Green River',
				slug: 'Green-River-WY-self-storage.html',
				yearly_visitors: 17,
			},
			{
				name: 'Powell',
				slug: 'Powell-WY-self-storage.html',
				yearly_visitors: 16,
			},
			{
				name: 'Riverton',
				slug: 'Riverton-WY-self-storage.html',
				yearly_visitors: 15,
			},
			{
				name: 'Rock Springs',
				slug: 'Rock-Springs-WY-self-storage.html',
				yearly_visitors: 15,
			},
		],
	},
];
